import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_application_summary_container';

const storeDetailsIds = {
  BUSINESS_ADDRESS_BLOCK: 'BUSINESS_ADDRESS_BLOCK',
  COMPANY_NAME: 'COMPANY_NAME',
  COUNTRY: 'COUNTRY',
  EMAIL: 'EMAIL',
  GOODS_CATEGORY: 'GOODS_CATEGORY',
  OPERATING_ADDRESS_BLOCK: 'OPERATING_ADDRESS_BLOCK',
  ORGANIZATION_ENTITY_TYPE: 'ORGANIZATION_ENTITY_TYPE',
  REGISTRATION_ID: 'REGISTRATION_ID',
  STORE_NAME: 'STORE_NAME',
  TOC: 'TOC',
  VAT_ID: 'VAT_ID',
  WEBSITE: 'WEBSITE',
};

const addressIds = {
  ADDRESS_COUNTRY: 'ADDRESS_COUNTRY',
  CITY: 'CITY',
  POSTAL_CODE: 'POSTAL_CODE',
  REGION: 'REGION',
  STREET: 'STREET',
};

const stakeholderIds = {
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
  NAME: 'NAME',
  PERSONAL_ID: 'PERSONAL_ID',
  STAKEHOLDER_BLOCK: 'STAKEHOLDER_BLOCK',
};

const ids = {
  ...addCyPrefixToIDs(cyPrefix, {
    CHECKBOX_TERMS_AND_CONDITIONS: 'CHECKBOX_TERMS_AND_CONDITIONS',
    CHECKBOX_PRICING_ANNEX: 'CHECKBOX_PRICING_ANNEX',
    BTN_SUBMIT: 'BTN_SUBMIT',
  }),
  ...addCyPrefixToIDs(`${cyPrefix}_store_details`, storeDetailsIds),
  ...addCyPrefixToIDs(`${cyPrefix}_address`, addressIds),
  ...addCyPrefixToIDs(`${cyPrefix}_stakeholder`, stakeholderIds),
};

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
export const CY_APPLICATION_CONFIRMATION_CONTAINER_IDS = ids;
